import { useState } from 'react'
import { LuSearch, LuCircleCheck, LuCircleX, LuClock, LuLoader, LuTriangleAlert } from 'react-icons/lu'
import { getBatchStatus } from '../services/transferService'
import './EstadoPage.css'

function EstadoPage() {
  const [processId, setProcessId] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState(null)

  const handleSearch = async () => {
    if (!processId.trim()) {
      setError('Ingrese un Process ID')
      return
    }

    setLoading(true)
    setError('')
    setResult(null)

    try {
      const response = await getBatchStatus(processId.trim())
      setResult(response.data)
    } catch (err) {
      setError(err.response?.data?.error || 'Error al consultar estado')
    } finally {
      setLoading(false)
    }
  }

  const getStatusIcon = (status) => {
    switch (status) {
      case 'finished':
        return <LuCircleCheck className="status-icon success" />
      case 'in_progress':
        return <LuLoader className="status-icon progress spinning" />
      case 'queued':
        return <LuClock className="status-icon pending" />
      default:
        return <LuClock className="status-icon" />
    }
  }

  const getStatusText = (status) => {
    switch (status) {
      case 'finished':
        return 'Finalizado'
      case 'in_progress':
        return 'En Proceso'
      case 'queued':
        return 'En Cola'
      default:
        return status || 'Desconocido'
    }
  }

  const getStatusClass = (status) => {
    switch (status) {
      case 'finished':
        return 'status-success'
      case 'in_progress':
        return 'status-progress'
      case 'queued':
        return 'status-pending'
      default:
        return ''
    }
  }

  // Extraer las transferencias del resultado
  // La estructura es: result.data.data (array de transferencias)
  const getTransfers = () => {
    if (!result) return []
    // Intentar diferentes estructuras posibles
    if (result.data && result.data.data && Array.isArray(result.data.data)) {
      return result.data.data
    }
    if (result.data && Array.isArray(result.data)) {
      return result.data
    }
    return []
  }

  const transfers = getTransfers()
  
  console.log('Result:', result)
  console.log('Transfers:', transfers)

  return (
    <div className="estado-page">
      <div className="page-header">
        <h1>Estado de Lotes</h1>
        <p>Consulte el estado de sus transferencias masivas</p>
      </div>

      <div className="search-card">
        <div className="search-form">
          <div className="form-group">
            <label>Process ID (UUID)</label>
            <input
              type="text"
              value={processId}
              onChange={(e) => setProcessId(e.target.value)}
              placeholder="ej: a1b2c3d4-e5f6-4g7h-8i9j-k0l1m2n3o4p5"
              className="form-control"
            />
          </div>
          <button 
            onClick={handleSearch} 
            className="btn-search"
            disabled={loading}
          >
            {loading ? <LuLoader className="spinning" /> : <LuSearch />}
            {loading ? 'Consultando...' : 'Consultar Estado'}
          </button>
        </div>
      </div>

      {error && (
        <div className="error-message">
          <LuCircleX /> {error}
        </div>
      )}

      {result && (
        <div className="result-card">
          <div className={`status-header ${getStatusClass(result.status)}`}>
            {getStatusIcon(result.status)}
            <div className="status-info">
              <h2>{getStatusText(result.status)}</h2>
              <p className="process-id">ID: {result.process_id}</p>
            </div>
          </div>

          <div className="result-details">
            <div className="detail-row">
              <span className="label">Total Transacciones</span>
              <span className="value">{result.transaction_count || transfers.length || 0}</span>
            </div>
            <div className="detail-row">
              <span className="label">Procesadas</span>
              <span className="value">{result.transaction_processed_count || transfers.length || 0}</span>
            </div>
            <div className="detail-row success">
              <span className="label">Exitosas</span>
              <span className="value">{result.transaction_success_count || 0}</span>
            </div>
            <div className="detail-row error">
              <span className="label">Fallidas</span>
              <span className="value">{result.transaction_fail_count != null ? result.transaction_fail_count : 0}</span>
            </div>
          </div>

          {/* Detalle de cada transferencia */}
          {transfers.length > 0 && (
            <div className="transfers-detail-section">
              <h3>Detalle por Transferencia</h3>
              <div className="transfers-list">
                {transfers.map((tx, idx) => {
                  const isSuccess = tx.response_code === '0200' || tx.code === '0200'
                  const description = tx.response_description || tx.description || 'Sin descripción'
                  
                  return (
                    <div key={idx} className={`transfer-item ${isSuccess ? 'success' : 'error'}`}>
                      <div className="transfer-number">
                        {isSuccess ? (
                          <LuCircleCheck className="transfer-icon success" />
                        ) : (
                          <LuTriangleAlert className="transfer-icon error" />
                        )}
                        <span>Transferencia {idx + 1}</span>
                      </div>
                      <div className="transfer-description">
                        {description}
                      </div>
                      {tx.from_cvu && tx.to_cvu && (
                        <div className="transfer-cvus">
                          <span className="cvu-label">De:</span> {tx.from_cvu}
                          <span className="cvu-separator">→</span>
                          <span className="cvu-label">A:</span> {tx.to_cvu}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default EstadoPage
